var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"customTree"},[_c('nested-draggable',{attrs:{"tasks":_vm.listData,"options":_vm.options},on:{"clickNode":_vm.clickNode,"contextmenu":_vm.contextmenu,"setState":_vm.setState}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-221d12a6","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tree/NewTree.vue
// module id = 209
// module chunks = 0